import { useLanguage } from '@cobliteam/i18n';
import type { IconNames } from '@cobliteam/ui/icons';
import { getTextForLanguage } from '@cobliteam/ui-business/utils/getTextForLanguage';
import { getSingular } from '@cobliteam/utils/pluralize';
import useSearch from '../../../hooks/useSearch';
import type { PageWithCategory } from '../../../types';
import CardHeader from '../../Cards/CardHeader';

const PageDetail = () => {
  const { selectedItem } = useSearch();
  const item = selectedItem as PageWithCategory;
  const { currentLanguage } = useLanguage();

  const group = item.group ? `${getSingular(item.group)} -` : '';
  const title = `${group} ${item.title}`.trim();
  if (!selectedItem) return null;

  return (
    <div className='relative flex h-[500px] w-full flex-col gap-4 overflow-hidden overflow-y-auto p-4'>
      <CardHeader
        icon={(item.sidebar?.icon as IconNames) || item.category.icon}
        color={item.category.color}
        title={title}
        subtitle={getTextForLanguage(item.description, currentLanguage)}
        linkTooltip='Ir para página'
        link={item.url}
      />
    </div>
  );
};

export default PageDetail;
